/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `EN-US` - EN-US
 * * `DE` - DE
 * * `FR` - FR
 * * `IT` - IT
 * * `AR` - AR
 * * `NB` - NB
 * @export
 */
export const SingleTurnChatLanguageEnum = {
  enUs: 'EN-US',
  de: 'DE',
  fr: 'FR',
  it: 'IT',
  ar: 'AR',
  nb: 'NB',
} as const;
export type SingleTurnChatLanguageEnum = (typeof SingleTurnChatLanguageEnum)[keyof typeof SingleTurnChatLanguageEnum];

export function instanceOfSingleTurnChatLanguageEnum(value: any): boolean {
  for (const key in SingleTurnChatLanguageEnum) {
    if (Object.prototype.hasOwnProperty.call(SingleTurnChatLanguageEnum, key)) {
      if ((SingleTurnChatLanguageEnum as Record<string, SingleTurnChatLanguageEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SingleTurnChatLanguageEnumFromJSON(json: any): SingleTurnChatLanguageEnum {
  return SingleTurnChatLanguageEnumFromJSONTyped(json, false);
}

export function SingleTurnChatLanguageEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatLanguageEnum {
  return json as SingleTurnChatLanguageEnum;
}

export function SingleTurnChatLanguageEnumToJSON(value?: SingleTurnChatLanguageEnum | null): any {
  return value as any;
}
